export default __webpack_public_path__ + "static/media/kili-pack1.20261181.jpg";